import { render, staticRenderFns } from "./ErrPage.vue?vue&type=template&id=985703a2&scoped=true&"
import script from "./ErrPage.vue?vue&type=script&lang=js&"
export * from "./ErrPage.vue?vue&type=script&lang=js&"
import style0 from "./ErrPage.vue?vue&type=style&index=0&id=985703a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985703a2",
  null
  
)

export default component.exports